import React from 'react';
import { Modal, Select, Upload, Button, Input, Radio, DatePicker, message, InputNumber, Spin } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import Text from '../../basicElement/Text';
import $, { xToken } from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import { lowerToUpper } from '../../shared/formatElem';
import { getMatchOption } from '../../shared/selectFn';
import format from '../../shared/format';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import fp from '../../../utils/fp.js';
import './index.less';

const { Option } = Select;
const { Group } = Radio;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const dateFormat = "YYYY-MM-DD";


class MarkContractSign extends React.Component {
    state = {
        loading: false,
        visible: false,
        record: {},
        fileList: [],
        saveParams: {},
        contractTypeList: [],
        relationContractList: [],
        currencyList: [],
        belongingToUnitList: [],
        rateCanEdit: false,
        criterion:[],
        allTrue: true,
        isClear: true,
        markRed: false,
        rebateAmount: '',
    }

    show = (record) => {
        const {
            jdeApplyStatusShow,
            investigationId,
            relationJdeId,
            currencyExchangeRateId,
            exchangeRate,
            currencyName,
            dateShow,
            currencyCode,
            currencyExchangeRate,
            expectContractAmount,
            contractAmount,
            actualExpenseFee,
            actualFee,
            taxationFee,
            initialExpectContractAmount,
            initialContractAmount,
            initialActualExpenseFee,
            initialActualFee,
            initialTaxationFee,
            projectIdName,
            natureOfContract,
            signingUnit,
            unitOfSigningId,
            unitOfBelongingId,
            belongingToUnit,
            customerCompanyId,
            customerCompanyName,
            customerJdeCode,
            baUserId,
            baName,
            baCode,
            contractRelationSiteComment,
            customerProjectCode,
            havePaperContractShow,
        } = record;
        const contractParams = {};
        if (currencyCode !== 'CNY') {
            contractParams.expectContractAmount = initialExpectContractAmount;
            contractParams.contractAmount = initialContractAmount;
            contractParams.actualExpenseFee = initialActualExpenseFee;
            contractParams.actualFee = initialActualFee;
            contractParams.taxationFee = initialTaxationFee;
        } else {
            contractParams.expectContractAmount = expectContractAmount;
            contractParams.contractAmount = contractAmount;
            contractParams.actualExpenseFee = actualExpenseFee;
            contractParams.actualFee = actualFee;
            contractParams.taxationFee = taxationFee;
        }
        let saveParams = {};
        if (jdeApplyStatusShow == 'JDE号已发放' || jdeApplyStatusShow == 'BO审批关闭申请不通过' || jdeApplyStatusShow == 'PM审批关闭申请不通过'|| jdeApplyStatusShow == 'VP审批关闭申请不通过') {
            saveParams = {
                relationJdeId,
                customerCompanyId,
                customerCompanyName,
                customerJdeCode,
                baUserId,
                currencyExchangeRateId,
                exchangeRate,
                currencyName,
                dateShow,
                currencyExchangeRate,
                contractRelationSiteComment,
                customerProjectCode,
                ...contractParams,
            };
        } else if (jdeApplyStatusShow == '待PM审核合同金额' || jdeApplyStatusShow == '待CTA审核合同金额' || jdeApplyStatusShow == '待FIN审核合同金额') {
            saveParams = {
                ...record,
                ...contractParams,
                projectIdName,
                signingUnit: unitOfSigningId,
                signingUnitName: signingUnit,
                belongingToUnit: unitOfBelongingId,
                belongingToUnitName: belongingToUnit,
            };
        }
        saveParams.baUserName = baName && baCode ? `${baName}(${baCode})` : undefined;
        saveParams.havePaperContractShow = havePaperContractShow;
        const { signingUnitList } = this.props;
        const belongingToUnitList = (signingUnitList.find(i => i.unitOfSigningId == unitOfSigningId) || {}).belongings || [];
        this.setState({
            record,
            saveParams,
            visible: true,
            path: Date.now(),
            belongingToUnitList,
            criterion:[
                {
                    key: 'amount',
                    context:'关联合同扣除金额后，该合同剩余的合同额含税/原币<该合同“发票金额（含税）总金额或外币应税额”合计值',
                    processed: false,
                },{
                    key: 'custom',
                    context:'同JDE项目号下客户名称不一致，是否继续发号？',
                    processed: false,
                    noPassReason: '同JDE项目号下客户名称不一致，请调整客户信息或给新客户新建JDE号',
                },{
                    key: 'specifiesAmount',
                    context:'该JDE项目号有误或申请调整金额有误',
                    processed: false,
                    noPassReason: '累计明标合同金额或实报实销金额＜0，请调整合同额',
                    refuseReason: '重复提交',
                },{
                    key: 'noSpecifiesAmount',
                    context:'该JDE项目号有误或申请调整金额有误',
                    processed: false,
                    noPassReason: '累计非明标合同金额或实报实销金额＜0，请调整合同额',
                    refuseReason: '重复提交',
                },{
                    key: 'checkDate',
                    context:'同JDE项目号下合同开始时间、合同结束时间不一致，请修改',
                    processed: false,
                    noPassReason: '同JDE项目号下合同开始时间、合同结束时间不一致，请修改',
                },
            ],
        }, () => {
            const { curRole } = sessionStorage;
            this.loadAllCurrencyExchangeRateList();
            if (curRole === 'FIN') {
                this.loadTypeConfigureList();
                this.queryInvestigationStageByInvId(investigationId);
            }
            this.loadRelationContractList(investigationId); // 增加关联JDE
            if (natureOfContract === 'TERMINATION_CONTRACT' || natureOfContract === 'TERMINATION_LETTER') {
                this.queryInvFinishInfo(investigationId, () => this.loadFileList());
            } else {
                this.loadFileList();
            }
        });
    }

    hide = () => {
        this.setState({
            fileList: [],
            visible: false,
            path: '',
            saveParams: {},
            criterion:[],
            isClear: true,
            rebateAmount: '',
        });
    }
	
	loadJdeInfo = () => {
			
		const { saveParams, record: { jdeApplyStatusShow,natureOfContract,natureOfContractShow } } = this.state;
		const {
            investigationJdeCode,
			relationJdeCode
        } = saveParams;
		const jde = natureOfContractShow == '补充合同' ? '' : (natureOfContractShow == '终止合同' || natureOfContractShow == '终止函') ? relationJdeCode : investigationJdeCode;
		
		// if(natureOfContract === 'FIRST_CONTRACT' || natureOfContract === 'RENEW_CONTRACT') {
			// jdeCode = saveParams.jde;
		// }
		// if(natureOfContract === 'SUPPLEMENT_CONTRACT') {
			// jdeCode = saveParams.investigationJdeCode;
		// }
			if(jde != null && jde != ''){
                const options = {
            method: 'post',
            url: API_URL.contract.queryJdeInfoByJdeCode,
            data: { jdeCode:jde},
            dataType: 'json',
            doneResult: data => {
				//获取到了回传数据
				if(data.investigationJdeContractCode) {
					
					saveParams.autoLoadJdeInfo = '1';
					saveParams.invoiceRate = data.invoiceRate;
					saveParams.investigationContractTypeId = String(data.contractTypeId);
					saveParams.contractTypeValue = String(data.contractTypeValue);
					this.setState({
					saveParams
					});
				} else {
					saveParams.autoLoadJdeInfo = '';
					saveParams.invoiceRate = '';
					saveParams.investigationContractTypeId = undefined;
					this.setState({
					saveParams
					});
				}
            }
        };
        $.sendRequest(options);
			}
    }
	
	loadJdeInfo2 = (e) => {
			
        const { saveParams, record: { jdeApplyStatusShow,natureOfContract,natureOfContractShow  } } = this.state;
		const {
            investigationJdeCode
        } = saveParams;
		
		// if(natureOfContract === 'FIRST_CONTRACT' || natureOfContract === 'RENEW_CONTRACT') {
			// jdeCode = saveParams.jde;
		// }
		// if(natureOfContract === 'SUPPLEMENT_CONTRACT') {
			// jdeCode = saveParams.investigationJdeCode;
		// }
		
			if(investigationJdeCode != null && investigationJdeCode != ''){
                this.queryChildJdeByInvId(investigationJdeCode);
                this.queryRebate(investigationJdeCode);
                // const options = {
                //     method: 'post',
                //     url: API_URL.contract.queryJdeInfoByJdeCode,
                //     data: { jdeCode:investigationJdeCode},
                //     dataType: 'json',
                //     doneResult: data => {
                //         //获取到了回传数据
                //         if(data.investigationJdeContractCode) {
                //             saveParams.autoLoadJdeInfo = '1';
                //             saveParams.invoiceRate = data.invoiceRate;
                //             saveParams.investigationContractTypeId = String(data.contractTypeId);
                //             saveParams.contractTypeValue = String(data.contractTypeValue);
                //             this.setState({
                //             saveParams
                //             });
                //         } else {
                //             saveParams.autoLoadJdeInfo = '';
                //             saveParams.invoiceRate = '';
                //             saveParams.investigationContractTypeId = undefined;
                //             this.setState({
                //             saveParams
                //             });
                //         }
                //     }
                // };
                // $.sendRequest(options);
			} else {
                this.setState({
                    rebateAmount: undefined,
                });
            }
    }

    queryChildJdeByInvId = jdeCodeData => {
        const { record, saveParams } = this.state;
        const { investigationId, contractIsSpecifiesAmount, natureOfContractShow, } = record;
        const {
            investigationJdeCode,
            relationJdeCode,
        } = saveParams;
        const jde = natureOfContractShow == '补充合同' ? '' : (natureOfContractShow == '终止合同' || natureOfContractShow == '终止函') ? relationJdeCode : investigationJdeCode;

        const options = {
            method: 'POST',
            url: API_URL.contract.queryChildJdeByInvId,
            data: {
                contractIsSigned: '1',
                investigationId,
                jdeCode: jdeCodeData ? jdeCodeData : jde,
            },
            dataType: 'json',
            doneResult: res => {
                const { list = [] } = res;
                if (contractIsSpecifiesAmount == '1') {
                    if (list.length === 0) {
                        saveParams.autoLoadJdeInfo = '';
                        saveParams.isAuto = false;
                        saveParams.invoiceRate = '';
                        saveParams.investigationContractTypeId = undefined;
                        saveParams.contractTypeValue = undefined;
                        this.setState({
                            saveParams
                        });
                    } else {
                        saveParams.autoLoadJdeInfo = '1';
                        saveParams.isAuto = false;
                        saveParams.invoiceRate = list[0].invoiceRate;
                        saveParams.investigationContractTypeId = String(list[0].contractTypeId);
                        saveParams.contractTypeValue = String(list[0].contractTypeValue);
                        this.setState({ saveParams });
                    }
                } else {
                    if (list.length === 0) {
                        saveParams.autoLoadJdeInfo = '';
                        saveParams.isAuto = true;
                        saveParams.invoiceRate = '';
                        saveParams.investigationContractTypeId = '23';
                        saveParams.contractTypeValue = '开票';
                        this.setState({ saveParams });
                    } else {
                        saveParams.autoLoadJdeInfo = '1';
                        saveParams.isAuto = false;
                        saveParams.invoiceRate = list[0].invoiceRate;
                        saveParams.investigationContractTypeId = String(list[0].contractTypeId);
                        saveParams.contractTypeValue = String(list[0].contractTypeValue);
                        this.setState({ saveParams });
                    }
                }
            }
        }
        $.sendRequest(options)
    }

    queryRebate = (investigationJdeCode) => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryRebate,
            data: { investigationJdeCode },
            dataType: 'json',
            doneResult: res => {
                const { rebateAmount } = res;
                this.setState({
                    rebateAmount,
                });
            }
        };
        $.sendRequest(options);
    }

    loadAllCurrencyExchangeRateList = () => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryAllCurrencyExchangeRate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                this.setState({
                    currencyList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.typeConfigureList}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                contractTypeList: res.contractTypeList,
            });
        });
    }

    queryInvestigationStageByInvId = (investigationId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const markRed = (data || []).some(el => el.operation === 'BUSINESS_DATA_ARCHIVING');
                this.setState({ loading: false, markRed });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryInvFinishInfo = (investigationId, callback) => {
        const { saveParams } = this.state
        const options = {
            method: 'POST',
            url: API_URL.proContract.getInvTerminationApplyInfo,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data: { invTerminationApplyId, investigationPauseReason, fileList: terminationFileList } } = res;
                const { fileList } = this.state;
                if (invTerminationApplyId) {
                    terminationFileList.forEach((item, index) => {
                        const { name, fileMateId, invTerminationApplyId } = item;
                        fileList.push({
                            name,
                            response: { fileMetaId: fileMateId },
                            uid: `${invTerminationApplyId}.${index}`,
                        });
                    });
                }
                this.setState({ fileList , saveParams:{ ...saveParams, investigationPauseReason } }, () => {
                    callback && callback();
                });
            }
        };
        $.sendRequest(options);
    }

    loadFileList = () => {
        const { record: { jdeApplyId } } = this.state;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { fileList } = this.state;
                data.forEach((item, index) => {
                    const { name, fileMateId } = item;
                    fileList.push({
                        name,
                        response: { fileMetaId: fileMateId },
                        uid: index,
                    });
                });
                this.setState({ fileList });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    checkJdeApplyPrompt = (params, isFIN, natureOfContract, url ) => {
        if(params.approvalStatus !== 'AGREE') {
            if (isFIN && natureOfContract === 'SUPPLEMENT_CONTRACT') {
                this.sendServer(url, params, false);
            } else {
                this.sendServer(url, params, true);
            }
            return
        }
        const { record:{ jdeApplyId, jdeCode } } = this.state;
        const { currencyExchangeRateId, contractAmount, actualExpenseFee, taxationFee, investigationJdeCode } = params
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.checkJdeApplyPrompt,
            data: {
                jdeCode: investigationJdeCode,
                jdeApplyId,
                currencyExchangeRateId,
                contractAmount,
                actualExpenseFee,
                taxationFee,
            },
            dataType: 'json',
            doneResult: res => {
                const { criterion } = this.state;
                try {
                    criterion.forEach( (el, index) => {
                        if(!res[el.key] && !el.processed) {
                            el.index = index
                            throw el
                        }
                        el.processed = true;
                    })
                } catch (el) {
                    Modal.warning({
                        okText: '确定',
                        content: el.context,
                    });
                    el.processed = true;
                    criterion[el.index] = el;
                    this.setState({
                        loading: false,
                        criterion,
                        allTrue: false,
                    })
                    return
                }
                if( criterion.every( el => el.processed )) {
                    if (isFIN && natureOfContract === 'SUPPLEMENT_CONTRACT') {
                        this.sendServer(url, params, false);
                    } else {
                        this.sendServer(url, params, true);
                    }
                }
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { businessList } = this.props;
        const {
            record: {
                jdeApplyId,
                natureOfContract,
                jdeApplyStatusShow,
                jdeApplyIsInvestigationExists,
                isClinicalProject,
                natureOfContractShow,
                jdeApplySceneId,
            },
            saveParams,
            fileList,
            isExitComplateFirst,
            currencyList,
            record,
            isClear,
        } = this.state;
        saveParams.isRealitySettle=saveParams.isRealitySettle?saveParams.isRealitySettle:record.isRealitySettle;
        saveParams.isMsaSpecialDiscountCustom = saveParams.isMsaSpecialDiscountCustom?saveParams.isMsaSpecialDiscountCustom:record.isMsaSpecialDiscountCustom;
        saveParams.isDiscountTermValidity = saveParams.isDiscountTermValidity?saveParams.isDiscountTermValidity:record.isDiscountTermValidity;
        saveParams.isMsaSpecialContractReduce=saveParams.isRealitySettle ==1?null:saveParams.isMsaSpecialContractReduce?saveParams.isMsaSpecialContractReduce:record.isMsaSpecialContractReduce;
        const {
            contractAmount,
            contractIsSpecifiesAmount,
            relateJdeIsDeductAmount,
            contractStartDate,
            contractEndDate,
            approvalStatus,
            comments,
            investigationContractTypeId,
            lineOfBusiness,
            secondLineIds,
            belongingToUnit,
            signingUnit,
            investigationJdeCode,
            projectIdName,
            relationJdeId,
            currencyExchangeRateId,
            exchangeRate,
            expectContractAmount,
            actualExpenseFee,
            actualFee,
            rate,
            taxationFee,
            invoiceRate,
            customerProjectCode,
        } = saveParams;
        const { curRole } = sessionStorage;
        const isPM = curRole === 'PM' || curRole === 'PML';
        const isCTA = curRole === 'CTA';
        const isFIN = curRole === 'FIN';
        const isBDorBDO = curRole === 'BD' || curRole === 'BDO' || curRole === 'BDM' || curRole == 'BA' || curRole == 'BAL';
        const is1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
        const isWorkInAdvance = jdeApplySceneId == 1 || jdeApplySceneId == 4 || jdeApplySceneId == 7;
        const isInvestigationExists = jdeApplyIsInvestigationExists == '1';
        const isClinicalPro = isClinicalProject == 1;
        const isFirstContract = natureOfContractShow == '首次合同';
        // 不是临床项目
        const lineOfBusiness_editable = isFIN && is1Or2 && !isClinicalPro;
        const currencyCode = (currencyList.find(i => i.currencyExchangeRateId == currencyExchangeRateId) || {})['currencyCode'];
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);

        const scene1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
        const existPro = jdeApplyIsInvestigationExists == 1 && !scene1Or2;
        const FIRST_CONTRACT = natureOfContract == 'FIRST_CONTRACT';

        if (isBDorBDO || isFIN) {
            if (lineOfBusiness_editable && !lineOfBusiness) {
                message.warning('请选择业务线');
                return;
            }
            if ((secondLineList || []).length && lineOfBusiness_editable && !secondLineIds) {
                message.warning('请选择执行业务线二级分类');
                return;
            }
            if (isFIN) {
                if (!signingUnit) {
                    message.warning('请选择合同签署单位');
                    return;
                }
                if (!belongingToUnit) {
                    message.warning('请选择收入归属单位');
                    return;
                }
            }
            if (isBDorBDO) {
                if ((jdeApplySceneId == 1 || jdeApplySceneId == 4) && (!existPro || (natureOfContract && !FIRST_CONTRACT)) && !customerProjectCode) {
                    message.warning('请输入项目编号');
                    return;
                }
                if ((jdeApplySceneId == 1 || jdeApplySceneId == 4) && isExitComplateFirst && !relationJdeId) {
                    message.warning('请选择关联JDE');
                    return;
                }
                if (isWorkInAdvance && isFirstContract&& !saveParams.customerCompanyId) {
                    message.warning('请选择客户全名');
                    return;
                }
                if (isWorkInAdvance && !saveParams.baUserId) {
                    message.warning('请选择BA');
                    return;
                }
                if (!contractIsSpecifiesAmount) {
                    message.warning('请选择合同中是否明标合同金额');
                    return;
                }
            }
            if (!currencyExchangeRateId) {
                message.warning('请选择币种');
                return;
            }
            if (currencyCode !== 'CNY' && !exchangeRate) {
                message.warning('请输入汇率');
                return;
            }
            if (isFIN && (natureOfContractShow == '首次合同' || natureOfContractShow == '续签合同')) {
                if (!expectContractAmount && expectContractAmount !== 0) {
                    message.warning('请输入预计合同金额');
                    return;
                } else {
                    if (natureOfContract == 'FIRST_CONTRACT' && expectContractAmount < 0) {
                        message.warning('合同性质为“首次合同”时，预计合同金额不支持负数');
                        return;
                    }
                }
            }
            if (!contractAmount && contractAmount !== 0) {
                message.warning('请输入合同额含税');
                return;
            } else {
                if (natureOfContract == 'FIRST_CONTRACT' && contractAmount <= 0) {
                    message.warning('合同性质为“首次合同”时，合同额含税不支持负数和零');
                    return;
                } else if (natureOfContract !== 'SUPPLEMENT_CONTRACT' && contractAmount === 0) {
                    message.warning('合同额含税不支持零');
                    return;
                }
            }
            if (!(taxationFee || taxationFee === 0) || !(rate || rate === 0)) {
                message.warning('请输入合同税率或合同额税费');
                return;
            }
            if (isBDorBDO) {
                if (isInvestigationExists && isFirstContract && relationJdeId) {
                    if (!relateJdeIsDeductAmount) {
                        message.warning('请选择关联JDE是否需要扣除相应金额');
                        return;
                    }
                }
                if (!contractStartDate) {
                    message.warning('请选择合同开始时间');
                    return;
                }
                if (!contractEndDate) {
                    message.warning('请选择合同结束时间');
                    return;
                }
                if (!fileList.length) {
                    message.warning('请上传附件');
                    return;
                }
            }
        }
        if (isPM || isCTA || isFIN) {
            if (jdeApplyStatusShow == '待PM审核合同金额') {
                if (!approvalStatus) {
                    message.warning('请选择PM审核结论');
                    return;
                } else if (approvalStatus == 'DISAGREE' && !comments) {
                    message.warning('请输入审核不通过原因');
                    return;
                }
            } else if (jdeApplyStatusShow == '待CTA审核合同金额') {
                if (!approvalStatus) {
                    message.warning('请选择CTA审核结论');
                    return;
                } else if (approvalStatus == 'DISAGREE' && !comments) {
                    message.warning('请输入审核不通过原因');
                    return;
                }
            } else if (jdeApplyStatusShow == '待FIN审核合同金额') {
                if (!approvalStatus) {
                    message.warning('请选择FIN审核结论');
                    return;
                } else {
                    if (approvalStatus == 'AGREE') {
                        if (!investigationJdeCode && (natureOfContract === 'SUPPLEMENT_CONTRACT')) {
                            message.warning('请输入JDE项目号');
                            return;
                        } else if (investigationJdeCode && investigationJdeCode.length != 12) {
                            message.warning('JDE项目号格式不正确:固定为12位，可由数字字母组成');
                            return;
                        } else if(!projectIdName && (natureOfContract === 'SUPPLEMENT_CONTRACT')) {
                            message.warning('请输入名称(Project ID)');
                            return;
                        } else if (!investigationContractTypeId) {
                            message.warning('请选择计收入确认方式');
                            return;
                        } else if (!invoiceRate && invoiceRate !== 0) {
                            message.warning('请输入发票税率');
                            return;
                        }
                    } else if (approvalStatus == 'REJECT') {
                        if (!comments) {
                            message.warning('请输入拒绝原因');
                            return;
                        }
                    } else if (approvalStatus == 'DISAGREE') {
                        if (!comments) {
                            message.warning('请输入审核不通过原因');
                            return;
                        }
                    }
                }
            }
        }
        let url;
        if (isBDorBDO) {
            url = API_URL.contract.contractSignature;
        } else {
            if (jdeApplyStatusShow == '待PM审核合同金额' || jdeApplyStatusShow == '待CTA审核合同金额') {
                url = API_URL.contract.pmApprovalContractMoney;
            } else if (jdeApplyStatusShow == '待FIN审核合同金额') {
                url = API_URL.contract.finApprovalContractMoney;
            }
        }

        if (currencyCode === 'CNY') {
            saveParams.initialExpectContractAmount = '';  //预计合同金额（原币）
            saveParams.initialContractAmount = '';  //合同额含税（原币）
            saveParams.initialActualExpenseFee = '';  //实报实销费（原币）
            saveParams.initialActualFee = ''; //实报实销税费(原币)
            saveParams.initialTaxationFee = ''; //税费（原币）
        } else {
            saveParams.initialExpectContractAmount = expectContractAmount;  //预计合同金额（原币）
            saveParams.initialContractAmount = contractAmount;  //合同额含税（原币）
            saveParams.initialActualExpenseFee = actualExpenseFee;  //实报实销费（原币）
            saveParams.initialActualFee = actualFee; //实报实销税费(原币)
            saveParams.initialTaxationFee = taxationFee; //税费（原币）
        }

        const params = {
            jdeApplyId,
            ...saveParams,
        };

        if (currencyCode !== 'CNY') {
            params.expectContractAmount = (expectContractAmount || expectContractAmount === 0) ? (expectContractAmount * exchangeRate).toFixed(2) : '';  //预计合同金额（人民币）
            params.contractAmount = (contractAmount || contractAmount === 0) ? (contractAmount * exchangeRate).toFixed(2) : '';  //合同额含税（人民币）
            params.actualExpenseFee = (actualExpenseFee || actualExpenseFee === 0) ? (actualExpenseFee * exchangeRate).toFixed(2) : '';  //实报实销费（人民币）
            params.actualFee =  (actualFee || actualFee === 0) ? (actualFee * exchangeRate).toFixed(2) : ''; //实报实销税费(人民币)
            params.taxationFee = (taxationFee || taxationFee === 0) ? (taxationFee * exchangeRate).toFixed(2) : ''; //税费（人民币）
        }
        if(jdeApplyStatusShow == '待FIN审核合同金额') {
            this.checkJdeApplyPrompt(params, isFIN, natureOfContract, url)
            return
        }

        if (investigationContractTypeId != 23 && approvalStatus == 'AGREE' && contractIsSpecifiesAmount == '0' && isClear && isFIN) {
            Modal.warning({
                title: '',
                content: '合同金额为非明标金额，请确认计收入确认方式',
                okText: '确定',
                onOk: () => {
                    this.setState({ isClear: false });
                }
            })
        } else {
            if (isFIN && natureOfContract === 'SUPPLEMENT_CONTRACT') {
                this.sendServer(url, params, false);
            } else {
                this.sendServer(url, params, true);
            }
        }

    }

    sendServer = (url, params, isCheck) => {
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url,
            data: {
                isCheck,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { message: info, success } = res;
                if (info) {
                    Modal.confirm({
                        iconType: 'exclamation-circle',
                        title: <div style={{ marginLeft: 42 }}>{info}</div>,
                        onOk: () => {
                            this.sendServer(url, params, true);
                        },
                        onCancel: () => {
                            this.setState({ loading: false });
                        },
                    })
                } else {
                    message.success(success);
                    this.setState({
                        loading: false,
                    }, () => {
                        this.hide();
                        this.props.loadData();
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleNumberChange = (value, key, rateCanEdit = true) => {
        const { saveParams } = this.state;
        if(key == 'discountContractAmount'){
            if(value){
                if(typeof(value) == typeof(1)){
                    saveParams.discountContractAmount = Math.abs(value);
                }
                else{
                    saveParams.discountContractAmount = value
                }
            }else{
                saveParams.discountContractAmount = null;
            }
        }else if(key == 'rate'){
            saveParams[key] = value;
            rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rate' });
            return
        }else if(key == 'taxationFee'){
            saveParams[key] = value;
            rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rmb' });
            return
        }else{
            saveParams[key] = value;
        }
        this.setState({ saveParams });
    }

    handleNoPassReason = value => {
        const { criterion } = this.state;
        const arr = [];
        criterion.forEach( el => {
            el.processed && arr.push(el)
        })
        const comments = arr.length ? value == 'DISAGREE' ? arr[arr.length-1].noPassReason : arr[arr.length-1].refuseReason : '';
        return comments
    }

    handleInputChange = (e, key) => {
        const { saveParams, allTrue, record: { jdeApplyStatusShow,natureOfContract } } = this.state;
        const value = e.target.value;
        if (key == 'approvalStatus') {
            if ((jdeApplyStatusShow == '待PM审核合同金额' || jdeApplyStatusShow == '待CTA审核合同金额') && value == 'AGREE') {
                saveParams.comments = '';
            } else if (jdeApplyStatusShow == '待FIN审核合同金额') {
                if (value == 'AGREE') {
                    saveParams.comments = '';
					
					if(natureOfContract === 'FIRST_CONTRACT' || natureOfContract === 'RENEW_CONTRACT'){
						// this.loadJdeInfo();
                        this.queryChildJdeByInvId();
					}
                } 
				//else if (value == 'DISAGREE') 
				else {
					if(natureOfContract === 'FIRST_CONTRACT' || natureOfContract === 'RENEW_CONTRACT') {
						//首次、续签合同，不能清空之前填写的jde号
					} else {
						//补充合同，要清空填写的jde号
						saveParams.investigationJdeCode = '';
					}
					
					saveParams.projectIdName = '';
					saveParams.investigationContractTypeId = undefined;
					saveParams.contractTypeValue = '';
					saveParams.invoiceRate = '';
					saveParams.autoLoadJdeInfo = '';
                    saveParams.comments = !allTrue ? this.handleNoPassReason(value) : '';
                }
				
            }
        }

        if(key == 'isRealitySettle'){
            const value = e.target.value
            saveParams.isRealitySettle = value;
            if(value == 1){
                saveParams.isMsaSpecialContractReduce = null;
                saveParams.discountContractAmount = null;
            }else if(value == 0){
                saveParams.isMsaSpecialContractReduce = 0;
                saveParams.discountContractAmount = null;
            }
            this.setState({ saveParams });
            return
        }

        if( key == 'isMsaSpecialContractReduce'){
            const value = e.target.value
            saveParams.isMsaSpecialContractReduce = value;
            if(value == 0 ){
                saveParams.discountContractAmount = null;
            }
            this.setState({ saveParams });
            return
        }
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    handleDateChange = (value, key) => {
        let time = "";
        if (value) {
            time = value.format(dateFormat);
        }
        const { saveParams } = this.state;
        saveParams[key] = time;
        this.setState({ saveParams });
    }

    handleRetrieveChange = (option, key) => {
        const { saveParams } = this.state;
        switch (key) {
            case 'customerCompany': {
                const { value: id, text: name, customerCompanyCode } = option;
                saveParams.customerCompanyId = id;
                saveParams.customerCompanyName = name;
                saveParams.customerJdeCode = customerCompanyCode;
                this.setState({ saveParams });
                break;
            }
            case 'baUser': {
                const { value: id, text: name } = option;
                saveParams.baUserId = id;
                saveParams.baUserName = name;
                this.setState({ saveParams });
                break;
            }
            default:
                break;
        }
    }

    handleSelectChange = (value, key) => {
        const { saveParams } = this.state;
        const prevSigningUnit = saveParams.signingUnit;
        saveParams[key] = value;
        if (key === 'signingUnit') {
            const { signingUnitList } = this.props;
            const belongingToUnitList = (signingUnitList.find(i => i.unitOfSigningId == value) || {}).belongings || [];

            if (value && !belongingToUnitList.length) {
                saveParams.signingUnit = prevSigningUnit;
                message.warning('收入归属单位不能为空，请联系后台管理员为合同签署单位设置收入归属单位');
                return;
            }
            if (belongingToUnitList.length === 1) {
                saveParams.belongingToUnit = belongingToUnitList[0].unitOfBelongingId;
                saveParams.belongingToUnitName = belongingToUnitList[0].unitOfBelongingName; 
            } else {
                saveParams.belongingToUnit = undefined;
                saveParams.belongingToUnitName = undefined; 
            }
            this.setState({ belongingToUnitList });
        }
        // 币种的选择 展示当前的汇率
        if (key === 'currencyExchangeRateId') {
            const { currencyList = [] } = this.state;
            const rateItem = currencyList.find(i => i.currencyExchangeRateId == value);
            const { exchangeRate, currencyName, dateShow } = rateItem || {};
            saveParams.exchangeRate = exchangeRate;
            saveParams.currencyExchangeRate = exchangeRate;
            saveParams.currencyName = currencyName;
            saveParams.dateShow = dateShow;
            // saveParams.expectContractAmount = '';
            // saveParams.contractAmount = '';
            // saveParams.actualExpenseFee = '';
            // saveParams.taxationFee = '';
            // saveParams.actualFee = '';
        }
        if (key === 'lineOfBusiness') {
            saveParams.secondLineIds = undefined;
        }
        if (key === 'secondLineIds') {
            saveParams.secondLineIds = (value || []).join(',');
        }
        if( key === 'isMsaSpecialDiscountCustom'){
            if( !value || value == 0 ){
                saveParams.isMsaSpecialContractReduce = null;
                saveParams.discountContractAmount = null;
            }
        }
        if( key === 'isDiscountTermValidity'){
            if(!value || value == 0){
                saveParams.isMsaSpecialContractReduce = null;
                saveParams.discountContractAmount = null;
            }else if(value ==1 ){
                saveParams.isMsaSpecialContractReduce = 0;
                saveParams.discountContractAmount = null;
            }
        }
        this.setState({ saveParams });
    }

    loadRelationContractList = (investigationId) => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryRelationJdeId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                const isExitComplateFirst = data.some(item=>item.investigationJdeContractIsSigned == '1' && item.contractNature == 'FIRST_CONTRACT')
                this.setState({ relationContractList: data, isExitComplateFirst });
            }
        };
        $.sendRequest(options);
    }

    //判断用户是否是特殊优惠客户和是否在优惠有效期内
    customerCompanyChange = (value) => {
        const MsaSpecialDiscountCustom=value.isMsaSpecialDiscountCustom;
        const DiscountTermValidity=value.isDiscountTermValidity;
        this.handleSelectChange(MsaSpecialDiscountCustom, 'isMsaSpecialDiscountCustom');
        this.handleSelectChange(DiscountTermValidity, 'isDiscountTermValidity');
        this.handleSelectChange(true,'CustomChange')
    }

    handleChangeRateCanEdit = value => {
        this.setState({ rateCanEdit: value })
    }

    getDataList = () => {
        const { businessList, signingUnitList } = this.props;
        const { curRole } = sessionStorage;
        const {
            saveParams,
            record,
            fileList,
            contractTypeList,
            path = '',
            relationContractList,
            isExitComplateFirst,
            currencyList,
            rateCanEdit,
            belongingToUnitList,
            rebateAmount,
        } = this.state;
        //解决是否据实结算、优惠客户的默认值
        record.isRealitySettle=record.isRealitySettle?record.isRealitySettle:0;
        record.isMsaSpecialContractReduce=record.isDiscountTermValidity ==1?record.isMsaSpecialContractReduce?record.isMsaSpecialContractReduce:0:null;
        const {
            investigationName,
            jdeCode,
            expectContractAmount,
            investigationJdeCode,
            projectIdName,//
            contractIsSpecifiesAmount,
            contractIsSpecifiesAmountShow,
            contractAmount,
            relationJdeCode,
            actualExpenseFee,
            taxationFee,
            rate,
            actualFee,
            relateJdeIsDeductAmount,
            relateJdeIsDeductAmountShow,
            contractStartDate,
            contractStartDateShow,
            contractEndDate,
            contractEndDateShow,
            approvalStatus,
            comments,
            investigationContractTypeId,
            lineOfBusiness,
            belongingToUnitName,
            belongingToUnit,
            signingUnit,
            signingUnitName,
            relationJdeId,
            currencyExchangeRateId,               // 币种编码
            exchangeRate,                         // 汇率
            currencyName,                         // 币种名字
            dateShow,                             // 生效日期
            currencyExchangeRate,                 // 编辑时 历史汇率
            invoiceRate,
            secondLineIds,
            customerProjectCode,
			contractTypeValue,
            investigationPauseReason
        } = saveParams;
        const {
            jdeApplyId,
            jdeApplyStatusShow,
            jdeApplyIsInvestigationExists,
            isClinicalProject,
            isClinicalProjectShow,
            natureOfContractShow,
            jdeApplySceneId,
            secondLineNames,
            natureOfContract,
            terminationReason,
			curUserIsPm,
            isRealitySettle,//是否据实计算
            realitySettleShow,//是否据实计算show
            isMsaSpecialContractReduce,//是否从合同中扣减
            msaSpecialContractReduceShow,//是否从合同中扣减show
            discountContractAmount,
            isMsaSpecialDiscountCustom,//是否优惠客户
            isDiscountTermValidity,//是否在优惠有效期内
        } = record;

        const isCTA = curRole === 'CTA';
        const isFIN = curRole === 'FIN';
        const isPM = curRole === 'PM' || curRole === 'PML' || curUserIsPm;
        const isBDorBDO = fp.contains(curRole)(['BD', 'BDO', 'BDM', 'BA', 'BAL']);
        
        const is1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
        const isWorkInAdvance = jdeApplySceneId == 1 || jdeApplySceneId == 4 || jdeApplySceneId == 7;
        const isInvestigationExists = jdeApplyIsInvestigationExists == 1;
        const isClinicalPro = isClinicalProject == 1;
        const isFirstContract = natureOfContractShow == '首次合同';
        const jde = natureOfContractShow == '补充合同' ? '' : (natureOfContractShow == '终止合同' || natureOfContractShow == '终止函') ? relationJdeCode : investigationJdeCode;
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        const showSecondLine = (secondLineList || []).length > 0;
        // 不是临床项目
        const lineOfBusiness_editable = isFIN && is1Or2 && !isClinicalPro;

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId} disabled={!(i.groupId == 2)}>{i.typeValue}</Option>);
        const secondLineOption = (secondLineList || []).map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
        const signingUnitOptions = signingUnitList.map(i => <Option key={String(i.unitOfSigningId)}>{i.unitOfSigningName}</Option>);
        const belongingToUnitOptions = belongingToUnitList.map(i => <Option key={String(i.unitOfBelongingId)}>{i.unitOfBelongingName}</Option>);
        const contractTypeOptions = contractTypeList.map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
        const relationContractOptions = relationContractList.map(i => <Option key={String(i.investigationJdeContractId)}>{i.investigationJdeContractCode}</Option>);
        const currencyOption = currencyList.map(i => <Option key={String(i.currencyExchangeRateId)}>{`${i.currencyName}(${i.currencyCode})`}</Option>);

        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const newContractStartDate = contractStartDate ? moment(contractStartDate) : null;
        const newContractEndDate = contractEndDate ? moment(contractEndDate) : null;

        const scene1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
        const existPro = jdeApplyIsInvestigationExists == 1 && !scene1Or2;
        const FIRST_CONTRACT = natureOfContract == 'FIRST_CONTRACT';
		const autoLoadJdeInfo = saveParams.autoLoadJdeInfo == '1';
		const isRealitySettleed = (saveParams.isRealitySettle || saveParams.isRealitySettle===0) ?saveParams.isRealitySettle == 0:isRealitySettle==0;// 据实结算 否
        const isMsaSpecialContractReduceed = (saveParams.isMsaSpecialContractReduce || saveParams.isMsaSpecialContractReduce===0)? saveParams.isMsaSpecialContractReduce== 1:isMsaSpecialContractReduce==1;// MSA特殊优惠从合同额中扣减
        const isMsaSpecialDiscountCustomed = isMsaSpecialDiscountCustom == 1;// 特殊优惠客户
        const isDiscountTermValidityed = saveParams.CustomChange? saveParams.isDiscountTermValidity == 1: isDiscountTermValidity == 1;// 优惠有效期内
        // 税率
        let showRateMes = rate ? rate < 6 || rate > 8 : false;
    if( (!rate || rate == '') && (!taxationFee || taxationFee == '') && rateCanEdit) this.handleChangeRateCanEdit (false);
    if(rateCanEdit == 'rmb') {
        let rateValue = '';
        if ((taxationFee || taxationFee === 0) && (contractAmount || contractAmount === 0)) {
            if (contractAmount - taxationFee == 0) {
                if (contractAmount === 0) {
                    rateValue = 0;
                } else {
                    rateValue = 100;
                }
            } else {
                rateValue = taxationFee / (contractAmount - taxationFee) * 100;
                rateValue = Number.isNaN(rateValue) ? '' : myFixed(rateValue,2);
            }
            if( rateValue != rate && rateValue != '') {
                this.handleChangeRateCanEdit ('rmb');
                this.handleNumberChange(rateValue, 'rate', false);
            }
        }
        if(rateValue == '' && rate != null){
            this.handleChangeRateCanEdit (false);
            this.handleNumberChange(null, 'rate', false);
        }
    }
    if(rateCanEdit == 'rate') {
        let taxationFeeValue = '';
        if ((rate || rate === 0) && (contractAmount || contractAmount === 0)) {
            taxationFeeValue = contractAmount - contractAmount / ( 1 + rate / 100 );
            taxationFeeValue = Number.isNaN(taxationFeeValue) ? '' : myFixed(taxationFeeValue,2);
            if( taxationFeeValue != taxationFee && taxationFeeValue != '') {
                this.handleChangeRateCanEdit ('rate');
                this.handleNumberChange(taxationFeeValue, 'taxationFee', false);
            }
        }
        if(taxationFeeValue == '' && taxationFee != null){
            this.handleChangeRateCanEdit (false);
            this.handleNumberChange(null, 'taxationFee', false);
        }
    }
       //优惠金额（不含税）
        let discountContractAmountNoTaxValue ='';
        if((saveParams.discountContractAmount || saveParams.discountContractAmount == 0)&& (rate || rate == 0)){
            discountContractAmountNoTaxValue = saveParams.discountContractAmount*(1-rate/100);
            discountContractAmountNoTaxValue = Number.isNaN(discountContractAmountNoTaxValue) ? '' : myFixed(discountContractAmountNoTaxValue,2)
            // handleChange(discountContractAmountNoTaxValue, 'discountContractAmountNoTax')
        }else if((discountContractAmount || discountContractAmount == 0)&& (rate || rate == 0)){
            discountContractAmountNoTaxValue = discountContractAmount*(1-rate/100);
            discountContractAmountNoTaxValue = Number.isNaN(discountContractAmountNoTaxValue) ? '' : myFixed(discountContractAmountNoTaxValue,2)
            // handleChange(discountContractAmountNoTaxValue, 'discountContractAmountNoTax')
        }

        function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }

        const workInAdvanceDom = (
            <div>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label"><Text asterisk={isFirstContract&& isBDorBDO}>客户全名</Text></label>
                        <span className="ui-text">
                            {
                                (isFirstContract&& isBDorBDO) ?
                                    <SearchRetrieve
                                        keyword='customerCompanyName'
                                        style={{ width: 182 }}
                                        placeholder="输入名称检索"
                                        params={{ limit: 20 }}
                                        value={saveParams.customerCompanyName}
                                        url={API_URL.investigation.queryCustomerCompanyByName}
                                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                        onChange={(option) => {
                                            this.handleRetrieveChange(option, 'customerCompany')
                                            this.customerCompanyChange(option)
                                        }}
                                    />
                                :
                                    saveParams.customerCompanyName
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">客户JDE号</label>
                        <span className="ui-text">{saveParams.customerJdeCode}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label"><Text asterisk={isBDorBDO}>BA</Text></label>
                        <span className="ui-text">
                            {
                                isBDorBDO ?
                                    <SearchRetrieve
                                        keyword='keyWord'
                                        style={{ width: 182 }}
                                        placeholder="输入姓名/工号检索"
                                        value={saveParams.baUserName}
                                        params={{ limit: 20, roleCodes: 'BA,BAL' }}
                                        url={API_URL.teaching.queryEmpListByRoleCode}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={(option) => this.handleRetrieveChange(option, 'baUser')}
                                    />
                                :
                                    saveParams.baUserName
                            }
                        </span>
                    </div>
                </li>
            </div>
        );

        const currencyCode = (currencyList.find(i => i.currencyExchangeRateId == currencyExchangeRateId) || {})['currencyCode'];
        return (
            <div>
                {
                    (isCTA || isFIN || isPM) &&
                    <div>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目简称</label>
                                <span className="ui-text">{investigationName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">JDE主项目号</label>
                                <span className="ui-text">{jdeCode}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">此项目是否为临床项目</label>
                                <span className="ui-text">{isClinicalProjectShow}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">合同性质</label>
                                <span className="ui-text">{natureOfContractShow}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">关联JDE</label>
                                <span className="ui-text">{
                                    relateJdeIsDeductAmountShow == '是' ? 
                                    <a onClick={() => this.props.relationJdeShow(record)}>{relationJdeCode}</a>
                                    : relationJdeCode
                                }</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">JDE项目号</label>
                                <span className="ui-text">{jde}</span>
                            </div>
                        </li>
                        {workInAdvanceDom}
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{lineOfBusiness_editable && asterisk}业务线</label>
                                <span className="ui-text">
                                    {
                                        lineOfBusiness_editable ?
                                            <Select
                                                placeholder="请选择"
                                                style={{ width: 182 }}
                                                value={saveParams.lineOfBusiness}
                                                onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                                            >
                                                {businessOption}
                                            </Select>
                                        :
                                            record.lineOfBusinessString
                                    }
                                </span>
                            </div>
                        </li>
                        {
                            showSecondLine &&
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">{lineOfBusiness_editable && asterisk}执行业务线二级分类</label>
                                    <span className="ui-text">
                                        {
                                            lineOfBusiness_editable ?
                                                <Select
                                                    mode="multiple"
                                                    allowClear={true}
                                                    placeholder="请选择"
                                                    style={{width: 182}}
                                                    value={secondLineIds ? secondLineIds.split(',') : []}
                                                    onChange={value => this.handleSelectChange(value, 'secondLineIds')}
                                                >
                                                    {secondLineOption}
                                                </Select>
                                            :
                                                secondLineNames
                                        }
                                    </span>
                                </div>
                            </li>
                        }
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{isFIN && asterisk}合同签署单位</label>
                                <span className="ui-text">
                                    {
                                        isFIN ?
                                            <Select
                                                allowClear={true}
                                                placeholder="请选择"
                                                style={{width: 182}}
                                                value={signingUnit ? String(signingUnit) : undefined}
                                                onChange={value => this.handleSelectChange(value, 'signingUnit')}
                                            >
                                                {signingUnitOptions}
                                            </Select>
                                        :
                                            signingUnitName
                                    }
                                </span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{isFIN && asterisk}收入归属单位</label>
                                <span className="ui-text">
                                    {
                                        isFIN && (belongingToUnitList.length > 1) ?
                                            <Select
                                                allowClear={true}
                                                placeholder="请选择"
                                                style={{width: 182}}
                                                value={belongingToUnit ? String(belongingToUnit) : undefined}
                                                onChange={value => this.handleSelectChange(value, 'belongingToUnit')}
                                            >
                                                {belongingToUnitOptions}
                                            </Select>
                                        :
                                            belongingToUnitName
                                    }
                                </span>
                            </div>
                        </li>
                    </div>
                }
                {
                    isBDorBDO && (jdeApplySceneId == 1 || jdeApplySceneId == 4) && (!existPro || (natureOfContract && !FIRST_CONTRACT)) && 
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}项目编号</label>
                            <span className="ui-text">
                            <Input
                                placeholder="请输入"    
                                style={{ width: 182 }}
                                value={customerProjectCode}
                                onChange={e => this.handleInputChange(e, 'customerProjectCode')}
                            />
                            </span>
                        </div>
                    </li>
                }
                {
                    isBDorBDO && (jdeApplySceneId == 1 || jdeApplySceneId == 4) &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{isExitComplateFirst && asterisk}关联JDE</label>
                            <span className="ui-text">
                                <Select
                                    placeholder="请选择"
                                    style={{width: 182}}
                                    onChange={value => this.handleSelectChange(value, 'relationJdeId')}
                                    value={relationJdeId ? String(relationJdeId) : undefined}
                                    allowClear={true}
                                >
                                    {relationContractOptions}
                                </Select>
                            </span>
                        </div>
                    </li>
                }
                {isBDorBDO && workInAdvanceDom}
                {
                    isBDorBDO &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}合同中是否明标合同金额</label>
                            <span className="ui-text">
                                <RadioGroup onChange={e => this.handleInputChange(e, 'contractIsSpecifiesAmount')} value={contractIsSpecifiesAmount}>
                                    <Radio value='1'>是</Radio>
                                    <Radio value='0'>否</Radio>
                                </RadioGroup>
                            </span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{(isBDorBDO || isFIN) && asterisk}币种</label>
                        <span className="ui-text">
                            {
                                (isBDorBDO || isFIN) ?
                                    <Select
                                        placeholder="请选择"
                                        style={{width: 182}}
                                        value={currencyExchangeRateId ? String(currencyExchangeRateId) : undefined}
                                        onChange={value => this.handleSelectChange(value, 'currencyExchangeRateId')}
                                    >
                                        {currencyOption}
                                    </Select>
                                :
                                    currencyName && `${currencyName}(${currencyCode})`
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{(isBDorBDO || isFIN) && currencyCode !== 'CNY' && asterisk}汇率</label>
                        <span className="ui-text">
                            {
                                (isBDorBDO || isFIN) ?
                                    currencyCode === 'CNY' ?
                                        exchangeRate
                                    :
                                        <InputNumber
                                            placeholder="请输入"
                                            style={{width: 182}}
                                            value={exchangeRate}
                                            onChange={value => this.handleNumberChange(value, 'exchangeRate')}
                                        />
                                :
                                    exchangeRate
                            }
                        </span>
                    </div>
                    {
                        currencyCode !== 'CNY' &&
                        <div style={{clear:'both',marginLeft:225,paddingTop:10,color:'blue'}}>【{dateShow}: 1{currencyName}={currencyExchangeRate}人民币】</div>
                    }
                </li>
                {
                    (isCTA || isFIN) && (natureOfContractShow == '首次合同' || natureOfContractShow == '续签合同') &&
                    (   
                        currencyCode === 'CNY' ?
                            <div>
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">{(isBDorBDO || isFIN) && asterisk}预计合同金额/人民币</label>
                                        <span className="ui-text">
                                            {format('money', expectContractAmount)}&nbsp;元
                                        </span>
                                    </div>
                                </li>
                                {(isBDorBDO || isFIN) && lowerToUpper(expectContractAmount, 245)}
                            </div>
                        :
                            <div className="jde-rate">
                                <div className="left" style={{ width:'55%'}}>
                                    <div className="left lable" style={{width:'59.4%'}}>{(isBDorBDO || isFIN) && asterisk}预计合同金额/原币</div>
                                    <div className="right text-com" style={{width:'40.6%'}}>
                                        {format('money', expectContractAmount)}&nbsp;{currencyName}
                                    </div>
                                </div>
                                <div className="right" style={{ width:'45%'}}>
                                    <div className="left lable" style={{width:'50%'}}>预计合同金额/人民币</div>
                                    <div className="right text-com" style={{width:'50%'}}>
                                        {format('money', expectContractAmount, exchangeRate)}&nbsp;元
                                    </div>
                                </div>
                            </div>
                    )
                }
                {
                    !isBDorBDO &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">合同中是否明标合同金额</label>
                            <span className="ui-text">
                                {contractIsSpecifiesAmountShow}
                            </span>
                        </div>
                    </li>
                }
                {
                    currencyCode == 'CNY' && 
                    <div>
                        <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">{(isBDorBDO || isFIN) && asterisk}合同额含税/人民币</label>
                                    <span className="ui-text">
                                        {
                                            (isBDorBDO || isFIN) ?
                                                <InputNumber
                                                    maxLength="17"
                                                    precision={2}
                                                    max={99999999999}
                                                    style={{ width: 182 }}
                                                    value={contractAmount}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                    onChange={value => this.handleNumberChange(value, 'contractAmount')}
                                                />
                                            :
                                                contractAmount && `${contractAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        }
                                        &nbsp;元
                                    </span>
                                </div>
                            </li>
                            {(isBDorBDO || isFIN) && lowerToUpper(contractAmount, 245)}
                    </div>
                }
                {
                    currencyCode == 'CNY' && 
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{isBDorBDO && asterisk}合同税率</label>
                            <span className="ui-text">
                            {
                                (isBDorBDO || isFIN) ?
                                    <InputNumber
                                        maxLength="17"
                                        precision={2}
                                        disabled={!(!rateCanEdit || rateCanEdit == 'rate')}
                                        max={99999999999}
                                        style={{ width: 182 }}
                                        value={rate}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                        onChange={value => this.handleNumberChange(value, 'rate')}
                                    />
                                :
                                    rate && `${rate}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }&nbsp;%
                            {
                                showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                            }
                            </span>
                        </div>
                    </li>
                }
                {
                    currencyCode !== 'CNY' &&
                    <div className="jde-rate">
                        <div>
                            <div className="left" style={{ width:'55%'}}>
                                <div className="left lable" style={{width:'59.4%'}}>{(isBDorBDO || isFIN) && asterisk}合同额含税/原币</div>
                                <div className="right text-com" style={{width:'37%'}}>
                                    {
                                        (isBDorBDO || isFIN) ?
                                            <InputNumber
                                                maxLength="17"
                                                precision={2}
                                                max={99999999999}
                                                style={{ width: 100 }}
                                                value={contractAmount}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                onChange={value => this.handleNumberChange(value, 'contractAmount')}
                                            />
                                        :
                                            format('money', contractAmount)
                                    }&nbsp;{currencyName}
                                </div>
                            </div>
                            <div className="right" style={{ width:'45%'}}>
                                <div className="left lable" style={{width:'50%'}}>合同额含税/人民币</div>
                                <div className="right text-com" style={{width:'37%'}}>
                                    {format('money', contractAmount, exchangeRate)}&nbsp;元
                                </div>
                            </div>
                        </div>
                        <div className="jde-top">
                            <div className="left lable" style={{width:'10%',textAlign:'center',borderRight:0}}>其中<br/>需扣除</div>
                            <div className="right jde-left" style={{width:'90%'}}>
                                <div>
                                    <div className="left" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/原币</div>
                                        <div className="right text-com" style={{width:'46%'}}>
                                            {
                                                (isBDorBDO || isFIN) ?
                                                    <InputNumber
                                                        maxLength="17"
                                                        precision={2}
                                                        max={99999999999}
                                                        style={{ width: 100 }}
                                                        value={actualExpenseFee}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                        onChange={value => this.handleNumberChange(value, 'actualExpenseFee')}
                                                    />
                                                :
                                                    format('money', actualExpenseFee)
                                            }&nbsp;{currencyName}
                                        </div>
                                    </div>
                                    <div className="right" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/人民币</div>
                                        <div className="right text-com" style={{width:'37%'}}>
                                            {format('money', actualExpenseFee, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                </div>
                                <div className="jde-bottom">
                                    <div  className="left" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>实报实销税费/原币</div>
                                        <div className="right text-com" style={{width:'46%'}}>
                                            {
                                                (isBDorBDO || isFIN) ?
                                                    <InputNumber
                                                        maxLength="17"
                                                        precision={2}
                                                        max={99999999999}
                                                        style={{ width: 100 }}
                                                        value={actualFee}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                        onChange={value => this.handleNumberChange(value, 'actualFee')}
                                                    />
                                                :
                                                    format('money', actualFee)
                                            }&nbsp;{currencyName}
                                        </div>
                                    </div>
                                    <div className="right" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>实报实销税费/人民币</div>
                                        <div className="right text-com" style={{width:'37%'}}>
                                            {format('money', actualFee, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                </div>
                                <div className="jde-bottom">
                                    <div className="left" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>{asterisk}合同额税费/原币</div>
                                        <div className="right text-com" style={{width:'46%'}}>
                                            {
                                                (isBDorBDO || isFIN) ?
                                                    <InputNumber
                                                        maxLength="17"
                                                        precision={2}
                                                        disabled={!(!rateCanEdit || rateCanEdit == 'rmb')}
                                                        max={99999999999}
                                                        style={{ width: 100 }}
                                                        value={taxationFee}
                                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                        onChange={value => this.handleNumberChange(value, 'taxationFee')}
                                                    />
                                                :
                                                    format('money', taxationFee)
                                            }&nbsp;{currencyName}
                                        </div>
                                    </div>
                                    <div className="right" style={{ width:'50%'}}>
                                        <div className="left lable" style={{width:'50%'}}>合同额税费/人民币</div>
                                        <div className="right text-com" style={{width:'37%'}}>
                                            {format('money', taxationFee, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="jde-top">
                            <div className="left lable" style={{width:'32.6%'}}>合同税率</div>
                            <div className="right text-com" style={{width:'59.4%'}}>
                            {
                                (isBDorBDO || isFIN) ?
                                    <InputNumber
                                        maxLength="17"
                                        precision={2}
                                        disabled={!(!rateCanEdit || rateCanEdit == 'rate')}
                                        max={99999999999}
                                        style={{ width: 100 }}
                                        value={rate}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                        onChange={value => this.handleNumberChange(value, 'rate')}
                                    />
                                :
                                    rate && `${rate}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            }&nbsp;%
                            {
                                showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                            }
                            </div>
                        </div>
                    </div>
                }
                {
                    currencyCode === 'CNY' &&
                    <div className="FeeBackground">
                        <div style={{ position: 'absolute', top: 0, left: 0, right: '88%', bottom: 0, background: '#f9f9f9', borderRight: "1px solid #ccc" }}>
                            <span style={{ position: "absolute", left: "10px", top: "50%", transform: 'translateY(-50%)' }}>&nbsp;其中<br />需扣除</span>
                        </div>
                        <div style={{ height: "100%", marginLeft: '12%' }}>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">实报实销(不含税)/人民币</label>
                                    <span className="ui-text">
                                        {
                                            (isBDorBDO || isFIN) ?
                                                <InputNumber
                                                    maxLength="17"
                                                    max={99999999999}
                                                    style={{ width: 182 }}
                                                    value={actualExpenseFee}
                                                    onChange={value => this.handleNumberChange(value, 'actualExpenseFee')}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    precision={2}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                />
                                            :
                                                format('money', actualExpenseFee)
                                        }
                                        &nbsp;元
                                    </span>
                                </div>
                            </li>
                            {
                                (isBDorBDO || isFIN) && lowerToUpper(actualExpenseFee)
                            }
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">实报实销税费/人民币</label>
                                    <span className="ui-text">
                                        {
                                            (isBDorBDO || isFIN) ?
                                                <InputNumber
                                                    maxLength="17"
                                                    max={99999999999}
                                                    style={{ width: 182 }}
                                                    value={actualFee}
                                                    onChange={value => this.handleNumberChange(value, 'actualFee')}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    precision={2}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                />
                                            :
                                                format('money', actualFee)
                                        }
                                        &nbsp;元
                                    </span>
                                </div>
                            </li>
                            {
                                (isBDorBDO || isFIN) && lowerToUpper(actualFee)
                            }
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">{(isBDorBDO || isFIN) && asterisk}合同额税费/人民币</label>
                                    <span className="ui-text">
                                        {
                                            (isBDorBDO || isFIN) ?
                                                <InputNumber
                                                    maxLength="17"
                                                    max={99999999999}
                                                    disabled={!(!rateCanEdit || rateCanEdit == 'rmb')}
                                                    style={{ width: 182 }}
                                                    value={taxationFee}
                                                    onChange={value => this.handleNumberChange(value, 'taxationFee')}
                                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    precision={2}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                />
                                            :
                                                format('money', taxationFee)
                                        }
                                        &nbsp;元
                                    </span>
                                </div>
                            </li>
                            {
                                (isBDorBDO || isFIN) && lowerToUpper(taxationFee)
                            }
                        </div>
                    </div>
                }
                {
                    isInvestigationExists && isFirstContract && relationJdeId &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{isBDorBDO && asterisk}关联JDE是否需要扣除相应金额</label>
                            <span className="ui-text">
                                {
                                    isBDorBDO ?
                                        <RadioGroup onChange={e => this.handleInputChange(e, 'relateJdeIsDeductAmount')} value={relateJdeIsDeductAmount}>
                                            <Radio value='1'>是</Radio>
                                            <Radio value='0'>否</Radio>
                                        </RadioGroup>
                                    :
                                        relateJdeIsDeductAmountShow
                                }
                            </span>
                        </div>
                    </li>
                }
                {
                    (
                        <div>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>是否据实结算</Text></label>
                                    <span className="ui-text">{
                                        isBDorBDO?
                                        <RadioGroup onChange={e => this.handleInputChange(e, 'isRealitySettle')} value={(saveParams.isRealitySettle ||saveParams.isRealitySettle===0  )?saveParams.isRealitySettle:isRealitySettle}>
                                            <Radio value= {1}>是</Radio>
                                            <Radio value= {0}>否</Radio>
                                        </RadioGroup>
                                        :realitySettleShow
                                    }
                                    </span>
                                </div>
                            </li>
                            {
                                (isRealitySettleed && isDiscountTermValidityed) && 
                                (<div>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label" style={{padding:'0'}}><Text asterisk={true}>MSA特殊优惠是否从合同额中扣减</Text></label>
                                            <span className="ui-text">{
                                                isBDorBDO?
                                                <RadioGroup onChange={e => this.handleInputChange(e, 'isMsaSpecialContractReduce')} value={(saveParams.isMsaSpecialContractReduce || saveParams.isMsaSpecialContractReduce==0)?saveParams.isMsaSpecialContractReduce:isMsaSpecialContractReduce}>
                                                    <Radio value= {1}>是</Radio>
                                                    <Radio value= {0}>否</Radio>
                                                </RadioGroup>
                                                :msaSpecialContractReduceShow
                                            }
                                                
                                            </span>
                                        </div>
                                    </li>
                                    {
                                        isMsaSpecialContractReduceed && (
                                            <div>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label"><Text asterisk={true}>优惠金额（含税）/人民币</Text></label>
                                                        <span className="ui-text">{
                                                            isBDorBDO?
                                                            <InputNumber
                                                            maxLength="17"
                                                            max={99999999999}
                                                            style={{ width: 182 }}
                                                            value={saveParams.discountContractAmount?saveParams.discountContractAmount:discountContractAmount}
                                                            onChange={value => this.handleNumberChange(value, 'discountContractAmount')}
                                                            precision={2}
                                                        />:discountContractAmount
                                                        }&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label"><Text asterisk={true}>优惠金额（不含税）/人民币</Text></label>
                                                        <span className="ui-text" style={{ width: 186 }}>
                                                            {discountContractAmountNoTaxValue}&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                            </div>
                                        )
                                    }
                                </div>)
                            }
                        </div>
                    )
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{isBDorBDO && asterisk}合同开始时间</label>
                        <span className="ui-text">
                            {
                                isBDorBDO ?
                                    <DatePicker
                                        placeholder="请选择"
                                        style={{ width: 182 }}
                                        format={dateFormat}
                                        value={newContractStartDate}
                                        onChange={(e) => this.handleDateChange(e, "contractStartDate")}
                                    />
                                :
                                    contractStartDateShow
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{isBDorBDO && asterisk}合同结束时间</label>
                        <span className="ui-text">
                            {
                                isBDorBDO ?
                                    <DatePicker
                                        placeholder="请选择"
                                        style={{ width: 182 }}
                                        format={dateFormat}
                                        value={newContractEndDate}
                                        onChange={(e) => this.handleDateChange(e, "contractEndDate")}
                                    />
                                :
                                    contractEndDateShow
                            }
                        </span>
                    </div>
                </li>
                {
                    (natureOfContract == 'TERMINATION_CONTRACT' || natureOfContract == 'TERMINATION_LETTER') &&
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">项目终止原因</label>
                            <span className="ui-text">
                                {investigationPauseReason}
                            </span>
                        </div>
                    </li>
                }
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">备注</label>
                        <span className="ui-text">
                            {
                                isBDorBDO && isWorkInAdvance ?
                                    <TextArea
                                        value={saveParams.contractRelationSiteComment}
                                        placeholder="请输入"
                                        style={{ width: 240, height: 80 }}
                                        onChange={e => this.handleInputChange(e, 'contractRelationSiteComment')}
                                    />
                                :
                                    saveParams.contractRelationSiteComment
                            }
                        </span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">是否拥有纸质合同</label>
                        <span className="ui-text">{saveParams.havePaperContractShow}</span>
                    </div>
                </li>
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label">{isBDorBDO && asterisk}上传附件</label>
                        <span className="ui-text">
                            {
                                isBDorBDO ?
                                    <Upload
                                        action={API_URL.contract.uploadJdeCodeEnclosure}
                                        data={{
                                            path,
                                            jdeApplyId,
                                            uploadType: 'CONTRACT',
                                            curUserId: sessionStorage.userId,
                                            curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        }}
                                        beforeUpload={this.beforeUpload}
                                        onChange={this.handleChange}
                                        onRemove={this.handleRemove}
                                        fileList={fileList}
                                        headers={xToken}
                                    >
                                        <Button style={{ width: 80 }}>选择文件</Button>
                                    </Upload>
                                :
                                    fileList.map(i => <a onClick={e => this.downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>)
                            }
                        </span>
                    </div>
                </li>
                {
                    (isCTA || isFIN || isPM) &&
                    (
                        (jdeApplyStatusShow == '待CTA审核合同金额' || jdeApplyStatusShow == '待PM审核合同金额') ?
                            <div>
                                <hr style={{ margin: '10px 0' }} />
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label">{asterisk}{curRole === 'PML' ? 'PM' : curRole}审核结论</label>
                                        <span className="ui-text" style={{ width: 420 }}>
                                            <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                                <Radio value='AGREE'>审核通过</Radio>
                                                <Radio value='DISAGREE'>审核不通过</Radio>
                                            </RadioGroup>
                                        </span>
                                    </div>
                                </li>
                                {
                                    approvalStatus == 'DISAGREE' &&
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label clearAfter"></label>
                                            <span className="ui-text">
                                                <Input
                                                    placeholder="请输入审核不通过原因"
                                                    style={{width: 240}}
                                                    value={comments}
                                                    onChange={e => this.handleInputChange(e, 'comments')} 
                                                />
                                            </span>
                                        </div>
                                    </li>
                                }
                            </div>
                        :
                            jdeApplyStatusShow == '待FIN审核合同金额' ?
                                <div>
                                    <hr style={{ margin: '10px 0' }} />
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">{asterisk}FIN审核结论</label>
                                            <span className="ui-text" style={{ width: 300 }}>
                                                <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                                    <Radio value='AGREE'>审核通过</Radio>
                                                    {natureOfContract === 'SUPPLEMENT_CONTRACT' && <Radio value='REJECT'>拒绝发号</Radio>}
                                                    <Radio value='DISAGREE'>审核不通过</Radio>
                                                </RadioGroup>
                                            </span>
                                        </div>
                                    </li>
                                    {
                                        approvalStatus == 'AGREE' && 
                                        <div>
                                            {
                                                natureOfContract === 'SUPPLEMENT_CONTRACT' &&
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">{asterisk}JDE项目号</label>
                                                        <span className="ui-text">
                                                            <Input
                                                                placeholder="请输入"
                                                                style={{width: 182}}
                                                                value={investigationJdeCode}
                                                                onChange={e => this.handleInputChange(e, 'investigationJdeCode')}
																onBlur={e => this.loadJdeInfo2(e)}
                                                            />
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                            {
                                                (contractAmount < 0) &&
                                                <li className="preview-item" >
                                                    <div className="item">
                                                        <label className="ui-label">rebate含税金额/原币</label>
                                                        <span className="ui-text" style={{ color: 'red' }}>
                                                            {rebateAmount}
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                            {
                                                natureOfContract === 'SUPPLEMENT_CONTRACT' &&
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">{asterisk}名称(Project ID)</label>
                                                        <span className="ui-text">
                                                            <Input
                                                                placeholder="请输入"
                                                                style={{width: 182}}
                                                                value={projectIdName}
                                                                onChange={e => this.handleInputChange(e, 'projectIdName')}
                                                            />
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">{asterisk}计收入确认方式</label>
													{
													!autoLoadJdeInfo &&
                                                    (
                                                        saveParams.isAuto
                                                        ?
                                                        <span className="ui-text">{contractTypeValue}</span>
                                                        :
                                                        <span className="ui-text">
                                                            <Select
                                                                placeholder="请选择"
                                                                style={{width: 182}}
                                                                value={investigationContractTypeId}
                                                                onChange={value => this.handleSelectChange(value, 'investigationContractTypeId')}
                                                            >
                                                                {contractTypeOptions}
                                                            </Select>
                                                        </span>
                                                    )
													}
													{
														autoLoadJdeInfo && <span className="ui-text">{contractTypeValue}</span>
													}
                                                </div>
                                            </li>
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">{asterisk}发票税率</label>
													{
													!autoLoadJdeInfo &&
                                                    <span className="ui-text">
                                                        <InputNumber
                                                            precision={2}
                                                            placeholder="请输入"
                                                            style={{width: 182, verticalAlign: 'middle'}}
                                                            value={invoiceRate}
                                                            onChange={e => this.handleNumberChange(e, 'invoiceRate')}
                                                        />&nbsp; %
                                                    </span>
													}
													{
														autoLoadJdeInfo && <span className="ui-text">{invoiceRate}&nbsp; %</span>
													}
                                                </div>
                                            </li>
                                        </div>
                                    }
                                    {
                                        approvalStatus == 'REJECT' &&
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label">{asterisk}拒绝原因</label>
                                                <span className="ui-text">
                                                    <Input
                                                        placeholder="请输入拒绝原因"
                                                        style={{width: 240}}
                                                        value={comments}
                                                        onChange={e => this.handleInputChange(e, 'comments')}
                                                    />
                                                </span>
                                            </div>
                                        </li>
                                    }
                                    {
                                        approvalStatus == 'DISAGREE' &&
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label clearAfter"></label>
                                                <span className="ui-text">
                                                    <Input
                                                        placeholder="请输入审核不通过原因"
                                                        style={{width: 240}}
                                                        value={comments}
                                                        onChange={e => this.handleInputChange(e, 'comments')}
                                                    />
                                                </span>
                                            </div>
                                        </li>
                                    }
                                </div>
                            :
                                null
                    )
                }
            </div>
        )
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <=30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleChange = ({ file, fileList }) => {
        if (file.status == "done") {
            if (file.response.error) {
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({ fileList });
    }

    handleRemove = file => {
        const options = {
            method: 'POST',
            url: API_URL.contract.deleteJdeCodeEnclosure,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message.error(res.error);
                } else {
                    message.success(res.success);
                }
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, markRed } = this.state;
        const { curRole } = sessionStorage;
        return (
            <Modal
                title={fp.contains(curRole)(['BD', 'BDO', 'BDM', 'BA', 'BAL']) ? '标记合同签署' : '审核金额'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName={markRed ? "red-glow-modal" : "vertical-center-modal"}
                confirmLoading={loading}
                maskClosable={false}
                width="720px"
            >
                <div className="cont-cont" style={{ padding: '0 20px' }}>
                    <Spin spinning={loading}>
                        <ul className="preview-list apply-jde">
                            {this.getDataList()}
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

export default MarkContractSign;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/MarkContractSign.js